import { Link } from "react-router-dom";
import { SisenseContextProvider, DashboardById } from "@sisense/sdk-ui";

export default function SdkTestDashboard() {
  const sisenseUrl = process.env.REACT_APP_SISENSE_URL;
  const dashboardOid = process.env.REACT_APP_SISENSE_DASHBOARD_OID;

  return (
    <div className="fixed inset-0 bg-black">
      <div className="absolute top-0 left-0 right-0 h-12 px-4 flex items-center justify-between bg-black/70 backdrop-blur z-10">
        <Link to="/" className="text-white/90 hover:text-white underline">← Back</Link>
        <div className="text-white/80 text-sm">Compose SDK Test (SSO)</div>
      </div>

      <div className="absolute top-12 left-0 right-0 bottom-0 bg-black">
        <SisenseContextProvider
          url={sisenseUrl}
          ssoEnabled={true}
          onError={(err) => console.error("Sisense SDK error:", err)}
        >
          <div className="w-full h-full">
            <DashboardById dashboardOid={dashboardOid} />
          </div>
        </SisenseContextProvider>
      </div>
    </div>
  );
}
